import { Collapse, makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '~components/typography';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 4,
    marginBottom: -4,
  },

  error: {
    color: theme.colors.redDark,
  },

  warning: {
    color: theme.colors.orangeDark,
  },
}));

const FieldHelperText = React.forwardRef((props, ref) => {
  const { type, children, className, ...otherProps } = props;
  const classes = useStyles();

  return (
    <Collapse in={!!children} unmountOnExit>
      <Typography
        variant="body2"
        {...otherProps}
        className={classnames(
          classes.root,
          {
            [classes.error]: !type || type === 'error',
            [classes.warning]: type === 'warning',
          },
          className
        )}
        ref={ref}
      >
        {children}
      </Typography>
    </Collapse>
  );
});

FieldHelperText.propTypes = {
  type: PropTypes.oneOf(['error', 'warning']),
  children: PropTypes.node,
  className: PropTypes.string,
};

FieldHelperText.defaultProps = {
  type: undefined,
  children: null,
  className: undefined,
};

export default FieldHelperText;
